import React, { FC, memo } from 'react';

import Image from 'common/Image/Image';
import routes from 'utils/routeTranslator';

import './FeaturedCategories.scss';

type L4Category = {
  id: string;
  name: string;
  slug: string;
  mobileCoverUrl?: string;
};

type Props = {
  categories: L4Category[];
  l2Id?: string;
  city?: string;
};

const FeaturedCategories: FC<Props> = (props) => {
  const handleClick = (): void => {
    if (props.l2Id) {
      localStorage.setItem('wizardTouchPointButton', `rdr_kategorie_link_${props.l2Id}`);
    }
  };

  if (!props.categories || props.categories.length === 0) return null;

  return (
    <div className="featuredCategories">
      <ul className="featuredCategories__featuredList">
        {props.categories.map((category) => (
          <li className="featuredCategories__featuredItem" key={category.slug}>
            <a
              href={routes.get('front::category', {
                slug: category.slug,
                city: props.city,
              })}
              onClick={handleClick}
              className="featuredCategories__featuredLink"
            >
              {category.mobileCoverUrl && (
                <Image
                  src={category.mobileCoverUrl}
                  size="l"
                  webp
                  multiPixelRatios
                  className="featuredCategories__featuredLinkCover"
                  aria-hidden
                />
              )}
              <span className="featuredCategories__featuredLinkLabel">{category.name}</span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default memo(FeaturedCategories);
